export default __webpack_public_path__ + "static/ortho care-e881389ff1430d463b134088361c7228.png";